<script>
import formatters from '@/mixins/formatters.js';
export default {
  name: 'PayoutEmailLog',
  mixins: { formatters },
  data() {
    return {
      emailLogs: {
        data: [],
        current_page: 1,
        per_page: 10,
        total: 0,
      },
      loading: false,
    };
  },
  async mounted() {
   //  await this.fetchLogs({ page: 1, per_page: this.emailLogs.per_page, status: 'sent' });
    await this.fetchLogs({ page: 1, per_page: this.emailLogs.per_page });
  },
  methods: {
    async fetchLogs(params) {
      this.loading = true;
      try {
        const res = await this.$lionheart.get('/v2/payout-email-logs', { params });
        const payload = (res && res.data) || {};
        this.emailLogs = {
          data: payload.data || [],
          current_page: payload.current_page || params.page || 1,
          per_page: payload.per_page || params.per_page || 10,
          total: payload.total || (payload.data ? payload.data.length : 0),
        };
      } catch (e) {
        console.error('Failed to load email logs:', e);
        this.$bvToast && this.$bvToast.toast('Failed to load email logs.', { variant: 'danger', autoHideDelay: 2000 });
      } finally {
        this.loading = false;
      }
    },
    async paginate(page) {
      // await this.fetchLogs({ page, per_page: this.emailLogs.per_page, status: 'sent' });
      await this.fetchLogs({ page, per_page: this.emailLogs.per_page });
    },
    extractEmail(data) {
      if(data.status === 'confirmed') return '--';
      try {
        const emailObj = data.sending_email.split('|').join(' , ');
        return emailObj || '--';
      } catch (e) {
        return '--';
      }
    },
  }
};
</script>
<template>
  <div>
    <div class="d-flex justify-content-between px-3">
      <h4 class="mb-0">Payout Email Log</h4>
    </div>

    <div class="col-12 mt-3">
      <div class="table-responsive table-bordered visitors-table">
        <table id="dataTable" cellspacing="0" class="table table-bordered visitors-table mb-0" width="100%">
          <thead>
            <tr>
               <th>Sent Email Date/Time</th>
              <th>Facility Name</th>
              <th>Sent to</th>
              <th>Payout Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="4" class="text-center">Loading...</td>
            </tr>
            <tr v-else-if="!emailLogs.data || emailLogs.data.length === 0">
              <td colspan="4" class="text-center">No records found</td>
            </tr>
            <tr v-else v-for="(row, idx) in emailLogs.data" :key="idx">
               <td>{{ formatDateTimeToSlash(row.sent_at, true) || '—' }}</td>
              <td :title="row.name">{{ row.payout_header?.facility?.name }}</td>
              <td>{{ extractEmail(row) }}</td>
              <td>{{ formatDateToSlash(row.payout_header?.payout_date) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-sm-8 mt-2">
        <pagination
          v-model="emailLogs.current_page"
          :per-page="emailLogs.per_page"
          :records="emailLogs.total"
          @paginate="paginate"
        />
      </div>
    </div>
  </div>
</template>
